import { render, staticRenderFns } from "./RateTable.vue?vue&type=template&id=00358964&scoped=true&"
import script from "./RateTable.vue?vue&type=script&lang=js&"
export * from "./RateTable.vue?vue&type=script&lang=js&"
import style0 from "./RateTable.vue?vue&type=style&index=0&id=00358964&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00358964",
  null
  
)

export default component.exports